import { http } from '@/http/axios.js'
// 列表（全量不分页，可带 categoryName 过滤）
export function getListAPI(params) {
  return http({
    url: '/admin/storeGoodsCategory/list',
    method: 'get',
    params
  })
}
// detail
export function getDetailAPI(id) {
  return http({
    url: '/admin/storeGoodsCategory/detail',
    method: 'get',
    params: { id }
  })
}
// add
export function addAPI(data) {
  return http({
    url: '/admin/storeGoodsCategory/add',
    method: 'post',
    data
  })
}
// edit
export function editAPI(data) {
  return http({
    url: '/admin/storeGoodsCategory/edit',
    method: 'post',
    data
  })
}
// status
export function changeStatusAPI(data) {
  return http({
    url: '/admin/storeGoodsCategory/status/edit',
    method: 'post',
    data
  })
}
// delete
export function deleteAPI(id) {
  return http({
    url: '/admin/storeGoodsCategory/delete',
    method: 'post',
    data: { id }
  })
}
